import { render, staticRenderFns } from "./SkupStavkaCreate.vue?vue&type=template&id=1b3d093e&scoped=true&"
import script from "./SkupStavkaCreate.vue?vue&type=script&lang=js&"
export * from "./SkupStavkaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3d093e",
  null
  
)

export default component.exports